<template>
  <v-snackbar v-model="show" :color="color" :timeout="timeout" rounded="lg" bottom center>
    {{ text }}
  </v-snackbar>
</template>

<script>
// Component
export default {
  name: 'TheNotification',
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'notification/SHOW_MESSAGE') {
        this.text = state.notification.text
        this.color = state.notification.color
        this.timeout = state.notification.timeout
        this.show = true
      }
    })
  },
  data() {
    return {
      show: false,
      color: '',
      text: '',
      timeout: -1,
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-sheet.v-snack__wrapper {
  border-radius: 9px;
}
</style>
